//import { validation } from './constants'

export const submitCheck = (data: any, fresher: boolean) => {
  
  if (!data.resumeFileName)
    return {
      error: true,
      errorVal: "resume",
      errorMessage: `Please upload your resume`,
    };
  let mandatoryData: any = profileData(data, fresher);
  if (!isNull(mandatoryData)) {
    for (const keyName of Object.keys(mandatoryData)) {
      let childData: any = mandatoryData[keyName];
      switch (keyName) {
        case "DetailedProfile":
        case "WorkExperience":
        case "availability":
        case "Preferences":
          if (!isNull(keyName)) {   
            for (const sectionKeyName of Object.keys(childData)) {
              if (isNull(childData[sectionKeyName]))
                return {
                  error: true,
                  errorVal: keyName,
                  errorMessage: `Please fill ${sectionKeyName} in ${keyName}`,
                };
            }
          } else
            return {
              error: true,
              errorVal: keyName,
              errorMessage: `Please fill this section`,
            };
          break;

        default:
          if (keyName === "projects")
            if (childData.length < 2)
              return {
                error: true,
                errorVal: keyName,
                errorMessage: `Please fill atleast 2  ${keyName} to submit`,
              };

          if (childData.length == 0)
            return {
              error: true,
              errorVal: keyName,
              errorMessage: `Please fill atleast 1  ${keyName} to submit`,
            };

          for (const sectionKeyName of Object.keys(childData)) {
            let innerChildData = childData[sectionKeyName];
            for (const subSectionKeyName of Object.keys(innerChildData)) {
              if (isNull(innerChildData[subSectionKeyName])) {
                return {
                  error: true,
                  errorVal: keyName,
                  errorMessage: `Please fill ${subSectionKeyName} in  ${keyName}`,
                };
              }
            }
          }
          // profile, overallWorkExperience, availability, skills, workExperience, projects, education, languages
          break;
      }
    }
  } else
    return {
      error: true,
      errorVal: 0,
      errorMessage: `Data not fetched or is empty please refresh`,
    };

  return { error: false };
};

const profileData = (data: any, fresher: boolean) => {
  
  let profileData: any = {};
//   const {
//     profile,
//     overallWorkExperience,
//     availability,
//     skills,
//     workExperience,
//     projects,
//     education,
//     languages,
//   } = data;
  if (data)    
    profileData.DetailedProfile = {
      "First Name": data.firstName,
      "Last Name": data.lastName,
      "Country": data.country,
      'City': data.city,
      // "Social Profile" : data.linkedIn || data.stackoverflow || data.github ,
      //"Candidate Type": data.contractType,
      "Email": data.email,
      "phoneNumber": data.phoneNumber,
      "Job Role": (data.jobRoles && data.jobRoles.length > 0) ? data.jobRoles[0].name : '',
    };

  if (data)
    profileData.WorkExperience = {
      "Work Experience": data.workExperience,
    };

  if (data)
    profileData.availability = {
      "Availability": data.availability && data.availability.availabilityId,
    };

    if (data)
    profileData.Preferences = {
      "preference": data.preference,
    };

  if (data && data.techStack && data.techStack.length) {
    let skillsArray: any = [];
    data.techStack.map((element:any) => {
        if (!fresher) {
          skillsArray.push({
            SkillName: element.skill.skillName,
            expertise: element.expertise,
            experience: element.experience,
          });
        } else {
          skillsArray.push({
            SkillName: element.skill.skillName,
          });
        }
    });

    profileData.skills = skillsArray;
  }

  if (!fresher) {
    
    if (data && data.workHistory && data.workHistory.length) {
      let workHistoryArray: any = [];
      data.workHistory.map((element: any) => {
        let reqData:any={}
        reqData = {
          "Designation": element.designation,
          "Company Name": element.companyName,
          // description: element.description,
          "Start Date": element.startDate,
          "StillWorking": element.stillWorking,
          "EndDate" : element.stillWorking ? 1 : element.endDate
        }

        if (!element.stillWorking) {          
          delete reqData.StillWorking
          workHistoryArray.push(reqData);
        }
        else {          
          delete reqData.endDate
          workHistoryArray.push(reqData);
        }

      });
   
      profileData.workHistory = workHistoryArray;
    }

    if (data && data.project && data.project.length) {
      let projectsArray: any = [];
      data.project.map((element:any) => {
        projectsArray.push({
          "Project Name": element.name,
         // "doneFor": element.companyName,
         // "Contribution": element.contribution,
          // role: element.role
        });
      });

      profileData.projects = projectsArray;
    }
  }

  if (data && data.education && data.education.length) {
    let educationArray: any = [];
    data.education.map((element:any) => {
      educationArray.push({
        "College": element.institution,
        "Degree": element.degree,
      });
    });

    profileData.education = educationArray;
  }

  if (data && data.language && data.language.length) {
    let languagesArray: any = [];
    data.language.map((element:any) => {
      languagesArray.push({
          "Language Name": element.name,
          "proficiency": element.proficiency
      });
    });

    profileData.languages = languagesArray;
  }

  return profileData;
};

 //  const isObject = (value: any) => typeof value === "object" && value !== null;

const isNull = (data: any) => [undefined, null, ""].includes(data);
